import React from "react";
import banner from "../../images/products/products.png";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import NetworkSec from "./NetworkSec";
import AllProd from "./AllProd";
import BussDrivenSoft from "./BussDrivenSoft";
import CyberSec from "./CyberSec";
import { LuDownload } from "react-icons/lu";
import catalogue from '../../images/catalogue.pdf'

function ProductPage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("network_sec");

  const switchComp = () => {
    switch (activeTab) {
      case "network_sec":
        return <NetworkSec />;
      case "business_driven_software":
        return <BussDrivenSoft />;
      case "cyber_sec":
        return <CyberSec />;
      case "all_products":
        return <AllProd />;
      default:
        return <AllProd />;
    }
  };

  return (
    <div className="product-page w-full">
    <div className="relative w-full h-screen max-[500px]:h-[60vh] overflow-hidden">
  
  {/* Banner Image */}
  <img
    src={banner}
    alt="img"
    className="w-full h-full object-cover"
  />

  {/* Dark Overlay */}
  <div className="absolute inset-0 bg-black/65"></div>

  {/* Content */}
  <div className="absolute bottom-[12%] max-[500px]:bottom-[20%] px-10 max-[500px]:px-5 z-10 text-white">
    
    {/* Small heading */}
    <p className="text-sm md:text-lg tracking-[4px] text-blue-400 font-semibold uppercase mb-4">
      ENTERPRISE PRODUCT PORTFOLIO
    </p>

    {/* Main Heading */}
    <h1 className="text-6xl max-[900px]:text-4xl max-[500px]:text-2xl font-bold leading-tight max-w-4xl">
      Focused software platforms for security, operations, and business
      management.
    </h1>

    {/* Description */}
    <p className="mt-6 text-lg max-[500px]:text-sm text-gray-200 max-w-4xl leading-relaxed">
      Explore MapleCloud’s enterprise software portfolio across AI-powered
      security operations, monitoring, zero trust access, enterprise
      management, IT operations, and SaaS business workflows.
    </p>
  </div>
</div>
 <div className="w-full flex items-center justify-center mt-5 text-md">
  <a
    href={catalogue}
    download
    className="
      group relative px-8 py-3 rounded-full overflow-hidden 
      bg-gradient-to-r from-purple-600 to-fuchsia-500 
      shadow-[0_0_15px_rgba(200,0,255,0.4)]
      hover:shadow-[0_0_25px_rgba(200,0,255,0.8)]
      transition-all duration-300 ease-in-out flex items-center gap-3
    "
    title="Download Brochure"
  >
    <span className="absolute inset-0 w-full h-full bg-fuchsia-400 opacity-0 group-hover:opacity-20 blur-2xl transition-all duration-500"></span>
    <span className="text-white text-2xl group-hover:rotate-12 group-hover:scale-110 transition-all duration-300">
      <LuDownload />
    </span>
    <span className="text-white font-semibold tracking-wide font-Inter transition-all duration-300">
      Download Products Portfolio
    </span>
  </a>
</div>



      <div className="flex justify-center w-full items-center">
        <div className="flex justify-between mt-3 w-4/5 transition-none mx-6 border-b border-gray-300 flex-wrap md:flex-nowrap">
          <button
            className={`px-4 py-2 text-lg font-medium ${
              activeTab === "network_sec"
                ? "text-white border-b-4  border-blue-400"
                : "text-gray-500 hover:text-white"
            }`}
            onClick={() => setActiveTab("network_sec")}
          >
            Network Security
          </button>
          <button
            className={`px-4 py-2 text-lg font-medium ${
              activeTab === "cyber_sec"
                ? "text-white border-b-4 border-blue-400"
                : "text-gray-500 hover:text-white"
            }`}
            onClick={() => setActiveTab("cyber_sec")}
          >
            Cyber Security
          </button>
          <button
            className={`px-4 py-2 text-lg font-medium ${
              activeTab === "business_driven_software"
                ? "text-white border-b-4 border-blue-400"
                : "text-gray-500 hover:text-white"
            }`}
            onClick={() => setActiveTab("business_driven_software")}
          >
            Business Application
          </button>
          <button
            className={`px-4 py-2 text-lg font-medium ${
              activeTab === "all_products"
                ? "text-white border-b-4 border-blue-400"
                : "text-gray-500 hover:text-white"
            }`}
            onClick={() => setActiveTab("all_products")}
          >
            All Products
          </button>
        </div>
      </div>
      <div className="w-full px-4 py-6">{switchComp()}</div>
    </div>
  );
}

export default ProductPage;
